import { render, staticRenderFns } from "./UnderwearPersonality.vue?vue&type=template&id=f17396ba&scoped=true&"
import script from "./UnderwearPersonality.vue?vue&type=script&lang=js&"
export * from "./UnderwearPersonality.vue?vue&type=script&lang=js&"
import style0 from "./UnderwearPersonality.vue?vue&type=style&index=0&id=f17396ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17396ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
